let stars = 0;
let wait = false;
let ratingStar = 0;
$(() => {
    // добавление рейтинга звездами
    $('form.comment_form .rating').mousemove(function (e) {
        let offX = (e.offsetX || e.clientX - $(e.target).offset().left);
        $(this).find('.rating_in').css('width', (parseInt(offX / 9) + 1) * 9);
    }).click(function (e) {
        let offX = (e.offsetX || e.clientX - $(e.target).offset().left);
        let rating = (parseInt(offX / 9) + 1);
        ratingStar = ((parseInt(offX / 9) + 1) * 9);
        $('input[name="rating"]').val(rating);
        try {
            $('#rating_num').html(rating);
            stars = rating * 20;
        } catch (er) {
        }
    }).mouseleave(function () {
        if (!wait) {
            $(this).find('.rating_in').css('width', ratingStar);
        }
    });
    // отправка рейтинга
    $('.set-rating-feedback').click(function () {
        let id = $(this).attr('data-id');
        let type = $(this).attr('data-type');
        let th = this;
        if ($(th).prop('disabled')) {
            return false;
        }
        $.post('/ajax/comment_rating.php', {
            'id': id,
            'type': type
        }).done(function (data) {
            let res = parseInt(data, 10);
            if (res > 0) {
                $(th).find('.rating-count').html(res);
                $(th).prop('disabled', true);
                modalNotice('Спасибо, ваш голос учтён');
                $('.js-modal-notice-btn').hide();
            }
        }).fail(function (response) {
        });
    });
});



// WEBPACK FOOTER //
// ./markup/components/product/feedback/feedback.js